import { Heading } from "@ttc3k/trekker";
import { PropsWithChildren } from "react";
import { Flex } from "styled-system/jsx";

type GroupRendererProps = {
  title: string;
  showTitle: boolean;
} & PropsWithChildren;

export const GroupRenderer = ({
  title,
  showTitle,
  children,
}: GroupRendererProps) => {
  return (
    <Flex flexDir="column">
      {showTitle && (
        <Heading
          size={"h5"}
          id={`GroupRendererAnchor_${title}`}
          pb={"150"}
          borderBottomWidth={"1px"}
          borderColor={"border.light"}
          borderBottomStyle={"solid"}
        >
          {title}
        </Heading>
      )}
      {children}
    </Flex>
  );
};
